<template>
    <v-flex xs12 style="text-align: center;">
        <div class="rcorners1">
            <span style="color: white; font-size: 32pt;">
                <slot></slot>
            </span>
        </div>
        <br />
    </v-flex>
</template>

<script>
    export default {
        name: 'RedBlock'
    }
</script>

<style>
    .rcorners1 {
        border-radius: 8px;
        background: #DB1918;
        padding: 0px;
    }
</style>
